module.exports = __webpack_public_path__ + "img/banner.b8fbd7c4.jpg";